import React from 'react';
import PropTypes from 'prop-types';

import {
  ThumbnailWrapper,
  ThumbnailBoxBorder,
  ThumbnailTitleWrapper,
  ThumbnailTitle,
  ThumbnailBox,
} from './styles';

function ThumbnailCard({ thumbnailUrl, title, handleOnClick }) {
  return (
    <ThumbnailWrapper onClick={handleOnClick}>
      <ThumbnailBoxBorder>
        <ThumbnailBox
          thumbnailUrl={thumbnailUrl}
        />
      </ThumbnailBoxBorder>
      <ThumbnailTitleWrapper>
        <ThumbnailTitle>
          {/* eslint-disable-next-line react/no-danger */}
          <p dangerouslySetInnerHTML={{ __html: title }} />
        </ThumbnailTitle>
      </ThumbnailTitleWrapper>
    </ThumbnailWrapper>
  );
}

ThumbnailCard.propTypes = {
  title: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  handleOnClick: PropTypes.func,
};

export default ThumbnailCard;
